import React, { useEffect, useRef, useState } from "react";

import Style from "./Records.module.css";
import { Link, useNavigate } from "react-router-dom";
import SlideUpWrapper from "../Transitions/SlideUpWrapper";
import { _ToNormal, ObjectNotEmpty, setDate } from "../../Utils/helper";
import Icon from "react-icons-kit";

import { androidOpen } from "react-icons-kit/ionicons/androidOpen";

import styles from "../../pages/DashBoard/ExternalDash/Verifier/VerifyUsers.module.css";
import { BUTTONS } from "../../Utils/Strings";

import API from "../../ApiConfig";
import cogoToast from "cogo-toast-react-17-fix";
import ReactPortalModal from "../ReactPortalModal";
import { CREATE_WA_REQUEST, GET_WA_REQUEST_FIELDS, MARK_NOTIFICATION_VIEWED, RESEND_CONSENT_LINK } from "../../Utils/constant";
import Loader from "../Loader";
import { useSelector } from "react-redux";
import AnimatedLoader from "../AnimationLoader";
import SearchStatus from "../../pages/DashBoard/ExternalDash/Employment/SearchStatus";
const AddDetails = ({
  AddDetailsData,
  fieldsData,
  handleChange,
  comment,
  setComment,
  file,
  setFile,
  handleSubmit,
  submitloading,
  formErrors,
}) => {
  useEffect(() => {
    if (AddDetailsData?.verifier_remarks) {
      setComment(AddDetailsData?.verifier_remarks);
    }
  }, [AddDetailsData]);
  return (
    <div className={Style.AddDetails}>
      <div className={styles.mainContainer}>
        <div className={styles.tableHeader}>
          <h3 className="heading">Employee Name: {AddDetailsData?.name}</h3>
        </div>
      </div>

      {formErrors && (
        <div
          style={{
            backgroundColor: "#fee2e2",
            color: "#b91c1c",
            padding: "0.75rem 1rem",
            borderRadius: "8px",
            marginBottom: "1rem",
            fontWeight: "500",
            textAlign: "center",
          }}
        >
          {formErrors}
        </div>
      )}
      <div>
        <table
          style={{ width: "100%", textAlign: "left", marginBottom: "1rem" }}
        >
          <tbody>
            {fieldsData.map((item) => (
              <tr
                key={item.id}
                className="credentials-header1"
                style={{ alignItems: "center" }}
              >
                <td className="credentials-td" style={{ width: "15rem" }}>
                {_ToNormal(item.field_name)}
                {item.is_required && <span style={{ color: "red" }}> *</span>}
                </td>
                <td className="credentials-td">
                  <input
                    type="text"
                    className={styles.input}
                    value={item.value}
                    placeholder={item.placeholder}
                    onChange={(e) => handleChange(item.id, e.target.value)}
                    disabled={AddDetailsData?.request_raised || item.field_name=="Employee Id"}
                    style={{ width: "30%" }}
                  />
                </td>
              </tr>
            ))}
           <tr
                className="credentials-header1"
                style={{ alignItems: "center" }}
              >
                <td className="credentials-td" style={{ width: "15rem" }}>
                {`Please upload the supporting document for adding details (Service Letter, Experience Letter)`}
              </td>
              <td className="credentials-td">
                {AddDetailsData?.request_raised &&
                AddDetailsData?.supporting_document_url ? (
                  <td
                    className="credentials-td"
                    style={{
                      width: "15rem",
                      fontSize: "16px",
                      fontWeight: "500",
                       alignItems:"center"
                    }}
                  >
                    <a
                      href={AddDetailsData?.supporting_document_url}
                      target="_blank"
                    >
                      Supporting Document
                    </a>
                  </td>
                ) : (
                  <td className="credentials-td" style={{ width: "15rem" }}>
                    <input
                      type="file"
                      onChange={(e) => setFile(e.target.files[0])}
                      accept=".pdf"
                      style={{ width: "32%" }}
                    />
                  </td>
                )}
              </td>
            </tr>
            <tr
                className="credentials-header1"
                style={{ alignItems: "center" }}
              >
                <td className="credentials-td" style={{ width: "15rem" }}>
                Please share your comments/remarks
              </td>

              <td className="credentials-td" style={{width:"15rem"}}>
                  <textarea
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    className={Style.AppealComment}
                    placeholder="Enter Comment"
                    disabled={AddDetailsData?.request_raised}
                    title="Verifier Remarks"
                  />
              </td>
            </tr>
          </tbody>
        </table>

        {AddDetailsData?.request_raised ? null : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <button
              type="submit"
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={AddDetailsData?.request_raised}
            >
              {submitloading ? "Adding......." : "Add Details"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
export default function Records({ data, Loading, requestList, isExternal }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [AddDetailsPopup, setAddDetailsPopup] = useState(false);
  const [submitloading, setSubmitLoading] = useState(false);
  const [comment, setComment] = useState("");
  const status = {
    0: "COMPLETED",
    1: "PENDING_ON_ISSUER",
    2: "PENDING_ON_HOLDER",
    3: "LOA_REQUIRED",
    4: "FNF_PENDING",
    5: "RECOVERY_PENDING",
    6: "EMPLOYEE_ABSCONDING",
  };
  const [AddDetailsData, setAddDetailsData] = useState(null);

  const [fieldsData, setFieldsData] = useState([]);
  const [file, setFile] = useState(null);
  const User = useSelector((state) => state.User);
  const [verification_req_id, setVerificationReqId] = useState("");
  const [formErrors, setFormErrors] = useState("");
  const [statusDescPopup, setStatusPopup]=useState(false)
  const [retriggerLoadingId, setRetriggerLoadingId] = useState(null);
  const handleAddDetails = (verification_id) => {
    setVerificationReqId(verification_id);
    setLoading(true);
    API.get(GET_WA_REQUEST_FIELDS + verification_id)
      .then((res) => {
        if (res.status == 200) {
          setLoading(false);
          setAddDetailsPopup(true);
          setAddDetailsData(res.data.data);
          setFieldsData(res.data.data.fields);
        }
      })
      .catch((err) => {
        setLoading(false);
        cogoToast.error(
          err.response.data.message.replace(/_/g, " ") ||
            "Error in getting Fields"
        );
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateFieldData()) {
      return;
    } else {
      const requestedFields = {};
      fieldsData.forEach((item) => {
        if (item.value !== "") {
          requestedFields[item.id] = item.value;
        }
      });
      const formdata = new FormData();
      formdata.append("verifier_id", User.id);
      formdata.append("verifier_payload", JSON.stringify(requestedFields));
      formdata.append("verification_request_id", verification_req_id);
      formdata.append("verifier_remarks", comment);
      formdata.append("supporting_document_upload", file);
      setSubmitLoading(true);
      API.post(CREATE_WA_REQUEST, formdata)
        .then((res) => {
          setSubmitLoading(false);
          if (res.data.status == 201) {
            setAddDetailsPopup(false);
            requestList();
          }
        })

        .catch((err) => {
          // debugger
          window.scrollTo({ top: 0, behavior: "smooth" })
          setSubmitLoading(false);

          setFormErrors(
            err.response?.data?.message || "Something went wrong"
          );
          cogoToast.error(
            err.response?.data?.message || "Something went wrong"
          );
        });
    }
  };

  const validateFieldData = () => {
    let isValid = true;
    setFormErrors("");
    if (!fieldsData.some((field) => field.value && field.value.trim() !== "")) {
      isValid = false;
      setFormErrors("enter data to raise appeal");
    } else if (!file) {
      isValid = false;
      setFormErrors("Please add file to procced ");
    } else if (comment.trim() == "") {
      isValid = false;
      setFormErrors("Please give some remarks");
    } 
    else if (fieldsData.some((item) => item.is_required && (!item.value || item.value.trim() === ""))) {
      const missingField = fieldsData.find(
        (item) => item.is_required && (!item.value || item.value.trim() === "")
      );
      isValid = false;
      setFormErrors(`Please fill required field: ${_ToNormal(missingField.field_name)}`);
    }
    else {
      for (let item of fieldsData) {
        if (item.value && item.regex[0]) {
          const pattern = new RegExp(item.regex[0]);
          if (!pattern.test(item.value)) {
            isValid = false;
            setFormErrors(
              `Invalid Value: ${_ToNormal(item.field_name)}`
            );
          }
        }
      }
    }
    return isValid;
  };
  const handleChange = (id, newValue) => {
    setFieldsData((prev) =>
      prev.map((fields, i) =>
        fields.id === id ? { ...fields, value: newValue } : fields
      )
    );
    if (formErrors) setFormErrors("");
  };

  const handleFileChange = (newFile) => {
    setFile(newFile);
    if (formErrors) setFormErrors("");
  };
  const handleCommentChange = (value) => {
    setComment(value);
    if (formErrors) setFormErrors("");
  };
  const updatePopup = (bool) => {
    setAddDetailsPopup(bool);
    setComment("");
    setFormErrors("");
  };

  const handleMarkNotificationViewed=(verification_id)=>{
    setLoading(true)
    let apiData={
      verifier_id:User.id,
      verification_request_id:verification_id
    }
    API.put(MARK_NOTIFICATION_VIEWED, apiData)
    .then(res=>{
      if(res.data.status==200){
        return
      }
    })
    .catch(err=>{
      console.log(err);
    })
  }

  const handleRetriggerConsent = (item) => {
    setRetriggerLoadingId(item.id);
    API.post(`${RESEND_CONSENT_LINK}?verification_request_id=${item.id}`
    )
      .then((res) => {
        setRetriggerLoadingId(null);

        cogoToast.success(res.data.message);
        requestList();
      })
      .catch((err) => {
        setRetriggerLoadingId(null);
        cogoToast.error(err.response?.data?.message || "Something went wrong");
      });
  };

  return (
    <>
      <SlideUpWrapper direction="slide-left">
        <div className="credentials-table">
          <AnimatedLoader
            isOpen={loading}
            loadingText={"Please Wait Getting Fields"}
          />
          <Loader isOpen={Loading} />
          <table
            style={{ border: "1px solid lightgray", borderRadius: "10px" }}
          >
            <thead>
              <tr className="credentials-header bg-lgray">
               {isExternal=="EXTERNAL"?null: <th className="credentials-th">
                  <div className="credentials-table-text">Transaction ID</div>
                </th>}
                <th className="credentials-th">
                  <div className="credentials-table-text">Emp ID</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Name</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Issuer Name</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Document Name</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Status <span style={{border:"2px solid lightgray", borderRadius:"9999px", padding:"3px", backgroundColor:"lightgray",cursor:"pointer"}} title="Status Description" onClick={()=>setStatusPopup(true)}>?</span></div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Remarks</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Source</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Created At</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Action</div>
                </th>
              </tr>
            </thead>

            <tbody
              className="Table-Content"
              style={data.length <= 6 ? { overflowY: "hidden" } : null}
            >
              {ObjectNotEmpty(data) ? (
                data.map((item, index) => (
                  <tr className="credentials-header1" key={index}>
                    {isExternal=="EXTERNAL"?null:  <td className="credentials-th">
                      <div className="credentials-table-text">
                        {item.transaction_id ?item.transaction_id: "NA"}
                      </div>
                    </td>}
                    <td className="credentials-th">
                      <div className="credentials-table-text">
                        {item.employee_id ? item.employee_id : "NA"}
                      </div>
                    </td>
                    <td className="credentials-th">
                      <div className="credentials-table-text">
                        {item.notification_info_name || item.name}
                      </div>
                    </td>
                    <td className="credentials-th">
                      {/* <Link to={`../forms/${item.form_uuid}`} state={{ formType: item.form_type }} className='credentials-table-text c-primary'> */}
                      <div className={`credentials-table-text`} style={{textAlign:"center"}}>
                        {item.issuer_company_name || item.issuer_company}
                      </div>
                      {/* </Link> */}
                    </td>
                    <td className="credentials-th">
                      <div className={`credentials-table-text`}>
                        {item.master_document_name || "Completed"}
                      </div>
                    </td>
                    <td className="credentials-th">
                      {/* <div className={`credentials-table-text ${item?.status == 0 ? 'Complete' : item?.status==3 ? 'Initiated': 'Pending'}`} style={{ width: '7rem', height:"auto" }}>{_ToNormal(status[item?.status]) || 'Completed'}</div> */}
                      <div
                        className={`credentials-table-text ${
                          [
                            "Completed",
                            "APPROVED",
                            "APPEAL_APPROVED",
                            "APPEAL_ISSUER_ADDED_DIFFERENT_VALUE",
                            "ISSUER_ADDED_DIFFERENT_VALUE",
                            "Details Shared Over Email",
                          ].includes(item?.status_description)
                            ? "Complete"
                            : ["Appeal Closed", "Appeal Responded"].includes(
                                item.status_description
                              )
                            ? "appeal_approved"
                            : ["Appeal Raised"].includes(
                                item.status_description
                              )
                            ? "appeal_raised"
                            : item?.status == 3
                            ? "Initiated":item.status_description=="Not An Employee"?"bg-gray-100 text-gray-700 border-gray-300":item.status_description=="Active Employee"?"bg-green-100 text-green-700 border-green-300":item.status_description=="Rejected"?"rejected"
                            : "Pending"
                        }`}
                        style={{ width: "100%", height: "auto", textAlign:"center" }}
                      >
                        {_ToNormal(item?.status_description)}
                      </div>
                    </td>
                    <td className="credentials-th">
                      <div className={`credentials-table-text Remarks`} style={{textAlign:"center", cursor:"pointer"}} title={item.remarks}>
                        {item.remarks?item.remarks:"NA"}
                      </div>

                    </td>
                    <td className="credentials-th">
                      <div className="credentials-table-text">


                        {_ToNormal(item?.source)}
                      </div>
                    </td>
                    <td className="credentials-th">
                      <div className="credentials-table-text">
                        {setDate(item.created_at)}
                      </div>
                    </td>
                    <td className="credentials-th">
                      {item.status == 0 
                      // || item.shared_data_id 
                      ? (
                        <div className="credentials-table-text">
                          <Link
                            to={`../emp/requestDetails/${item.shared_data_id}/${item.issuer_id}/${item.id}`}
                            state={{ formType: item.form_type }}
                            className={`link appeal_approved`}
                            onClick={()=>handleMarkNotificationViewed(item.id)}
                          >
                            <Icon icon={androidOpen} size={"1rem"} />
                            View
                          </Link>
                        </div>
                      ) : //   :
                      //   item.status==3?
                      //   <div className="credentials-table-text">
                      //     <div style={{cursor:"pointer"}} onClick={()=>handleUploadLOA(item?.id)}>
                      //       <Icon icon={androidOpen} size={'1rem'} />
                      //       Upload
                      //     </div>
                      // </div>
                      item.status_description == "Details Shared Over Email" && item.appeal_allowed ? (
                        <div className="credentials-table-text">
                          <Link
                            to={`../emp/WAAppeal/${item.id}`}
                            className={`link Initiated`}
                          >
                            <Icon icon={androidOpen} size={"1rem"} />
                            Raise Appeal
                          </Link>
                        </div>
                      ) : item.status_description == "Details Needed" ? (
                        <div>
                          <div
                            className={`link appeal_raised`}
                            style={{
                              cursor: "pointer",
                              fontSize: "16px",
                              width: "auto",
                              height: "auto",
                            }}
                            onClick={() => handleAddDetails(item.id)}
                          >
                            <Icon icon={androidOpen} size={"1rem"} /> Add
                            Details
                          </div>
                        </div>
                      ) : item.status_description ==
                        "Pending On Contributor" ? (
                        <div>
                          <div
                            className={`link Initiated`}
                            style={{
                              cursor: "pointer",
                              fontSize: "12px",
                              width: "auto",
                              height: "auto",
                            }}
                            onClick={() => handleAddDetails(item.id)}
                          >
                            <Icon icon={androidOpen} size={"1rem"} /> View
                            Details
                          </div>
                        </div>
                      ) : item.status_description == "Pending On Holder" &&
                        item.can_resend_holder_consent ? (
                        <button
                          className="btn btn-primary"
                          style={{ width: "auto" }}
                          disabled={retriggerLoadingId == item.id}
                          onClick={() => handleRetriggerConsent(item)}
                        >
                          {retriggerLoadingId == item.id
                            ? "Retriggering..."
                            : "Retrigger"}
                        </button>
                      ) : item.status_description=="Rejected" && item.can_resend_holder_consent && item.holder_consent_retrigger_count<item.max_rejected_consent_retrigger_count?
                      <button
                          className="btn btn-primary"
                          style={{ width: "auto" }}
                          disabled={retriggerLoadingId == item.id}
                          onClick={() => handleRetriggerConsent(item)}
                        >
                          {retriggerLoadingId == item.id
                            ? "Retriggering..."
                            : `${item.max_rejected_consent_retrigger_count - item.holder_consent_retrigger_count} Retriggers Left`}
                        </button>:null
                     }
                    </td>
                  </tr>
                ))
              ) : Loading ? (
                [...Array(2)].map((_, index) => (
                  <tr className="credentials-header" key={index}>
                    <td className="credentials-th">
                      <div className="shimmer" style={{ width: "7rem" }}></div>
                    </td>
                    <td className="credentials-th">
                      <div className="shimmer" style={{ width: "7rem" }}></div>
                    </td>
                    <td className="credentials-th">
                      <div className="shimmer" style={{ width: "7rem" }}></div>
                    </td>
                    <td className="credentials-th">
                      <div className="shimmer" style={{ width: "7rem" }}></div>
                    </td>
                    <td className="credentials-th">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          gap: "1rem",
                        }}
                      >
                        <div
                          className="shimmer"
                          style={{ width: "4rem", height: "2rem" }}
                        ></div>
                        <div
                          className="shimmer"
                          style={{ width: "4rem", height: "2rem" }}
                        ></div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="credentials-tr">
                  <td colSpan="6" className="credentials-td text-center">
                    <div className="Data_List">No Data Found</div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <ReactPortalModal
            title={"Add Details"}
            isOpen={AddDetailsPopup}
            onClose={updatePopup}
            blockOutsideClick={true}
          >
            <AddDetails
              AddDetailsData={AddDetailsData}
              fieldsData={fieldsData}
              handleChange={handleChange}
              comment={comment}
              setComment={handleCommentChange}
              file={file}
              setFile={handleFileChange}
              handleSubmit={handleSubmit}
              submitloading={submitloading}
              formErrors={formErrors}
            />
          </ReactPortalModal>
        </div>
        <ReactPortalModal isOpen={statusDescPopup} onClose={()=>setStatusPopup(false)}>
                <SearchStatus/>
            </ReactPortalModal>
      </SlideUpWrapper>
    </>
  );
}
